import Head from "next/head"
import DefaultLayout from "@/components/DefaultLayout"
import SliderBarLeft from "@/components/SliderBarLeft"
import SliderBarRight from "@/components/SliderBarRight"
import ShopInfo from "@/components/ShopInfo"
import styles from "@/styles/article/return-policy.module.scss"
import Image from 'next/image'
import { UpOutlined } from '@ant-design/icons';

import getConfig from 'next/config'
import Link from "next/link"
const { publicRuntimeConfig } = getConfig()
const imageDomain = publicRuntimeConfig.imageDomain

export default function AboutPayPal() {
  // 回到顶部
  const backToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // 添加平滑滚动效果
    })
  }


  return (
    <>
      <Head>
        <title>
          Online Shopping Australia - Beauty & Health, Computers, Toys, - Deals & Discounts | CrazySales
        </title>
        <meta
          name="keywords"
          content="Online Shopping Australia, online shopping sites, Home Shopping, Shopping Deals, Best Deals, Home Garden, Pet Supplies, Sports Fitness, Bedding Bath, Buy Online, Discount Shopping, Toys Hobbies, Beauty Health, Crazy Sales, Computers, IT, Christmas, Electronics, Automotive, Tools, Appliances, Baby, CrazySales"
        ></meta>
        <meta
          name="description"
          content="CrazySales.com.au - Australia's #1 online shopping website! Cheap bargains &amp; discounts with the top online shopping Australia store! From furniture, to toys &amp; hobbies, to appliances &amp; pet supplies -- we've got it all, with free shipping on selected items!"
        ></meta>
      </Head>

      <DefaultLayout notStickyNavbar={true}>
        <div className={`${styles['page-return-policy']} slider-wapper`}>
          <SliderBarLeft></SliderBarLeft>
          <SliderBarRight></SliderBarRight>

          <div className={styles["shop-info-box"]}>
            <ShopInfo hiddenContactus={true}></ShopInfo>
          </div>

          <div className={styles['content']}>
            <div className={styles['content-title']}>
              <Image src={`https://www.crazysales.com.au/images/2022v/img/pay/icon-payment-logo-paypal-Color.svg`} width={263} height={150} alt="afterpay" />
            </div>

            <div className={styles['answer-desc']}>
              <Link
                href="http://www.paypal.com.au"
                legacyBehavior
              >
                <a rel="noopener noreferrer" style={{ color: '#e42141' }}>
                  http://www.paypal.com.au
                </a>
              </Link>
            </div>
            <div className={styles['answer-desc']}>
              {`Founded in 1998, PayPal, an eBay Company, enables any individual or business with an email address to securely, easily and quickly send and receive payments online. PayPal's service builds on the existing financial infrastructure of bank accounts and credit cards and uses the world's most advanced proprietary fraud prevention systems to create a safe, global, real-time payment solution.`}
            </div>
            <br />
            <div className={styles['answer-desc']}>
              {`PayPal has quickly become a global leader in online payment solutions with 100 million account members worldwide. Available in 103 countries around the world, buyers and sellers on eBay, online retailers, online businesses, as well as traditional offline businesses are transacting with PayPal.`}
            </div>

            <div className={`${styles['ask-title']} padding-top-14`}>How does PayPal work?</div>
            <div className={styles['answer-desc']}>
              {`Once your name `}
              <Link
                href="https://www.paypal.com/cgi-bin/webscr?cmd=_registration-run"
                legacyBehavior
              >
                <a rel="noopener noreferrer" style={{ color: '#e42141', textDecoration: 'underline' }}>
                  signed up for a PayPal account
                </a>
              </Link>
              {` you can send and receive money online. When you send money, you can choose to fund your payments from your PayPal account balance, a credit card, or your bank account. Recipients are then notified via an email from PayPal that they have received a payment from you`}
            </div>
            <div className={`${styles['ask-title']} padding-top-14`}>To make a PayPal purchase:</div>
            <div className={styles['answer-desc']}>
              {`• Select PayPal during checkout on a merchant website or eBay`}<br></br>
              {`• Choose to fund your PayPal purchase with a credit card, bank account, or other source`}<br></br>
              {`• Y Funds are transferred securely through PayPal and money is deposited into the seller's PayPal account`}<br></br>
            </div>

            <div
              style={{ textAlign: 'center' }}>
              <Image
                className={styles['content-img']}
                src={`https://img.crazysales.com.au/images/Payment_pic03.gif`}
                alt={'return-policy-process'}
                width={532}
                height={139}
              ></Image>
            </div>

            <div className={`${styles['ask-title']} padding-top-14`}>PayPal saves you time</div>
            <div className={styles['answer-desc']}>
              • Keep all your financial information in one place<br></br>
              • Use different credit cards for different purchases<br></br>
              • Make payments directly from your bank account<br></br>
              • No more hassle typing credit card numbers each time you make a purchase<br></br>
              • Faster than money orders and cheques - no waiting for the mail, no waiting in line at the bank
            </div>

            <div className={`${styles['ask-title']} padding-top-14`}>PayPal is trusted worldwide</div>
            <div className={styles['answer-desc']}>
              • More than 100 million member accounts and still growing<br></br>
              • Used across the world in 103 countries and regions<br></br>
              • Widely accepted on merchant websites, preferred on eBay
            </div>

            <div className={`${styles['ask-title']} padding-top-14`}>PayPal is safe</div>
            <div className={styles['answer-desc']}>
              • Your financial information is never shared<br></br>
              • Sellers never see credit card or bank account numbers<br></br>
              • Experienced fraud prevention team fights fraud before it happens
            </div>

            <div className={`${styles['ask-title']} padding-top-14`}>PayPal is cost-effective</div>
            <div className={styles['answer-desc']}>
              • It is always free to make purchases<br></br>
              • Affordable pricing for all businesses<br></br>
            </div>
          </div>
        </div>
      </DefaultLayout>
    </>
  )
}